<template>
    <div class="row">
        <side-menu v-if="targetDate" :title="'勤怠編集'"></side-menu>
        <div :class="{'col-md-10 pt-3': targetDate != null}">
            <form @submit.prevent="edit">
                <div class="form-group">
                    <label>対象日</label>
                    <p v-if="targetDate">{{targetDate}}</p>
                    <li v-if="targetDates" v-for="date in targetDates" :key="date">{{date | displayDate}}
                    </li>
                </div>
                <div class="form-group">
                    <label>出勤時間</label>
                    <div>
                        <el-date-picker v-if="targetDate" v-model="workEdit.clockInDate" type="date" placeholder="デフォルトは対象日となります"></el-date-picker>
                        <select class="custom-select" name="clockInHour" v-model="workEdit.clockInHour">
                            <option v-for="startHour in 24" :key="startHour" :value="startHour -1">
                                {{startHour -1}}
                            </option>
                        </select>
                        <span class="w-5 m-2">時</span>
                        <select class="custom-select" name="clockInMin" v-model="workEdit.clockInMin">
                            <option v-for="startMin in 60" :key="startMin" :value="startMin -1">
                                {{startMin -1}}
                            </option>
                        </select>
                        <span class="w-5 m-2">分</span>
                    </div>
                </div>
                <div class="form-group">
                    <label>退勤時間<span v-if="targetDates.length > 0" class="">（一括編集の場合、日をまたぐ退勤はできません）</span></label>
                    <div>
                        <el-date-picker v-if="targetDate" v-model="workEdit.clockOutDate" type="date" placeholder="デフォルトは対象日となります"></el-date-picker>
                        <select class="custom-select" name="clockOutHour" v-model="workEdit.clockOutHour">
                            <option v-for="endHour in 24" :key="endHour" :value="endHour -1">
                                {{endHour -1}}
                            </option>
                        </select>
                        <span class="w-5 m-2">時</span>
                        <select class="custom-select" name="clockOutMin" v-model="workEdit.clockOutMin">
                            <option v-for="endMin in 60" :key="endMin" :value="endMin -1">
                                {{endMin -1}}
                            </option>
                        </select>
                        <span class="w-5 m-2">分</span>
                    </div>
                    <p v-if="workEdit.dayOff == 0 && leaveEarly" class="text-danger">早退になります。備考に理由を記入ください。</p>
                </div>
                <div class="form-group">
                    <label>休憩</label>
                    <div>
                        <select class="custom-select" name="breakTimeMinHour" v-model="workEdit.breakTimeMinHour">
                            <option v-for="breakHour in 24" :key="breakHour" :value="breakHour -1">
                                {{breakHour -1}}
                            </option>
                        </select>
                        <span class="w-5 m-2">：</span>
                        <select class="custom-select" name="breakTimeMinMinute" v-model="workEdit.breakTimeMinMinute">
                            <option v-for="breakMinute in 60" :key="breakMinute" :value="breakMinute  -1">
                                {{breakMinute -1}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                    <label>その他休憩</label>
                    <div>
                        <select class="custom-select" name="otherBreakTimeHour" v-model="workEdit.otherBreakTimeHour">
                            <option v-for="otherBreakHour in 24" :key="otherBreakHour" :value="otherBreakHour -1">
                                {{otherBreakHour -1}}
                            </option>
                        </select>
                        <span class="w-5 m-2">：</span>
                        <select class="custom-select" name="otherBreakTimeMinute" v-model="workEdit.otherBreakTimeMinute">
                            <option v-for="otherBreakMinute in 60" :key="otherBreakMinute" :value="otherBreakMinute -1">
                                {{otherBreakMinute -1}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                    <label>深夜帯休憩（22:00〜翌5:00までの間）</label>
                    <div>
                        <select class="custom-select" name="midnightBreakTimeHour" v-model="workEdit.midnightBreakTimeHour">
                            <option v-for="midnightBreakTimeHour in 24" :key="midnightBreakTimeHour" :value="midnightBreakTimeHour -1">
                                {{midnightBreakTimeHour -1}}
                            </option>
                        </select>
                        <span class="w-5 m-2">：</span>
                        <select class="custom-select" name="midnightBreakTimeMinute" v-model="workEdit.midnightBreakTimeMinute">
                            <option v-for="midnightBreakTimeMinute in 60" :key="midnightBreakTimeMinute" :value="midnightBreakTimeMinute -1">
                                {{midnightBreakTimeMinute -1}}
                            </option>
                        </select>
                    </div>
                </div>
                <input type="hidden" class="form-control" v-model="workEdit.edited"/>
                <div class="form-group radio-block">
                    <label>休暇
                        <span v-if="invalidLeaveRequestReason" class="text-danger">*申請理由は必須になります（空白のみも不可）</span>
                        <span id="day-off-notice" class="text-secondary" v-if="initLeaveRequest">（すでに休暇申請のある場合、休暇の編集はできません）</span>
                    </label>
                    <div class="radio" id="day-off-radio">
                        <div class="form-check">
                            <input type="radio" value="0" id="dayOff-00" name="dayOff" v-model="workEdit.dayOff" :disabled="initLeaveRequest" @click="checkDayOff(0)">
                            <label for="dayOff-00">なし</label>
                        </div>
                        <div class="form-check">
                            <!--すでに有給がTRUEの時、Disableにする。その場合、有給情報を送ると2度登録になるため、休暇のみPOSTする-->
                            <input type="radio" value="1" id="dayOff-01" name="dayOff" v-model="workEdit.dayOff" :disabled="initLeaveRequest" @click="checkDayOff(1)">
                            <label for="dayOff-01">半休</label>
                            <span v-if="workEdit.dayOff == 1">
                                <input type="checkbox" id="yukyu-half-check" class="ml-2" :checked="workEdit.leaveRequestType==1" :disabled="initLeaveRequest" @click="checkYukyu(1)">
                                <label for="yukyu-half-check">有給</label>
                                <input v-if="workEdit.leaveRequestType === 1" class="border-secondary" style="border: 1px solid; border-radius: 3px;" v-model="workEdit.leaveRequestReason" type="text" id="yukyu-half-reason" placeholder="申請理由をご記入ください" maxlength='255' size="30" :disabled="initLeaveRequest" required/>
                            </span>
                        </div>
                        <div class="form-check">
                            <!--すでに有給がTRUEの時、Disableにする。その場合、有給情報を送ると2度登録になるため、休暇のみPOSTする-->
                            <input type="radio" value="2" id="dayOff-02" name="dayOff" v-model="workEdit.dayOff"  :disabled="initLeaveRequest" @click="checkDayOff(2)">
                            <label for="dayOff-02">全休</label>
                            <span v-if="workEdit.dayOff == 2">
                                <input type="checkbox" id="yukyu-all-check" class="ml-2" :checked="workEdit.leaveRequestType==1" :disabled="initLeaveRequest" @click="checkYukyu(1)">
                                <label for="yukyu-all-check">有給</label>
                                <input v-if="workEdit.leaveRequestType === 1" class="border-secondary" style="border: 1px solid; border-radius: 3px;" v-model="workEdit.leaveRequestReason" type="text" id="yukyu-all-reason" placeholder="申請理由をご記入ください" maxlength='255' size="30" :disabled="initLeaveRequest" required/>
                            </span>
                        </div>
                        <div class="form-check">
                            <input type="radio" value="3" id="dayOff-03" name="dayOff" v-model="workEdit.dayOff" :disabled="initLeaveRequest" @click="checkDayOff(3)"/>
                            <label for="dayOff-03">特別休暇（夏季休暇、慶弔休暇、看護休暇、年末年始休暇など）</label>
                            <select v-if="workEdit.dayOff == 3" class="search-select custom-select" name="specialleave" v-model="workEdit.specialLeaveCd" :disabled="initLeaveRequest" required="required">
                                <option :selected="workEdit.specialLeaveCd == null"></option>
                                <option v-for="sl in specialLeaveList" :value="sl.id" :key="sl.id" :selected="workEdit.specialLeaveCd == sl.id" :disabled="sl.limitDays != null && (sl.limitDays - sl.count <= 0 || (targetDates.length > 0 && sl.limitDays - sl.count - targetDates.length <0))" :title="`${sl.name} (残り${sl.limitDays - sl.count}日)`">
                                    {{ sl.name }} {{ sl.limitDays != null ? `(残り${sl.limitDays - sl.count}日)` : ''}}
                                </option>
                            </select><span v-if="workEdit.dayOff == 3" class="text-danger">*</span>
                        </div>
                        <div class="form-check">
                            <input type="radio" value="4" id="dayOff-04" name="dayOff" v-model="workEdit.dayOff" :disabled="initLeaveRequest" @click="checkDayOff(4)"/>
                            <label for="dayOff-04">代休</label>
                        </div>
                        <div class="form-check">
                            <input type="radio" value="5" id="dayOff-05" name="dayOff" v-model="workEdit.dayOff" :disabled="initLeaveRequest" @click="checkDayOff(5)">
                            <label for="dayOff-05">その他 諸定休暇</label>
                        </div>
                    </div>
                    <p class="text-warning" id="message-day-off-all" v-if="workEdit.dayOff > 1">※「なし」、「半休」以外の場合、入力された時間は編集後クリアされます</p>
                </div>
                <div class="form-group">
                    <label>早出</label>
                    <div>
                        <input type="checkbox" id="earlyShift" class="ml-2" v-model="workEdit.earlyShift">
                    </div>
                </div>
                <div class="form-group radio-block">
                    <label>勤務形態</label>
                    <div class="radio" id="workStyle-radio">
                        <div class="form-check">
                            <input type="radio" value="出社" id="workStyle-00" name="workStyle" v-model="workEdit.workStyle">
                            <label for="workStyle-00">出社</label>
                        </div>
                        <div class="form-check">
                            <input type="radio" value="テレワーク" id="workStyle-01" name="workStyle" v-model="workEdit.workStyle">
                            <label for="workStyle-01">テレワーク</label>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label>備考</label><span v-if="(workEdit.dayOff > 0 && !workEdit.leaveRequestReason && workEdit.dayOff != 3) || (workEdit.dayOff == 0 && leaveEarly)" class="text-danger" id="label-note">*</span>
                    <textarea id="input-note" class="form-control" rows="4" v-model="workEdit.note" placeholder="休暇理由などご記入ください" 
                        :required="(workEdit.dayOff > 0 && !workEdit.leaveRequestReason && workEdit.dayOff != 3) 
                            || (workEdit.dayOff == 0 && leaveEarly)"
                    ></textarea>
                </div>

                <button v-if="!targetDates.length" type="button" class="btn btn-outline-secondary" data-dismiss="modal" @click="$router.go(-1)">キャンセル</button>
                <button type="submit" class="btn btn-primary">編集</button>
            </form>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import SideMenu from "../SideMenu.vue";
import WorkAPI from "../../../api/work-api.js";
import LeaveRequestAPI from '../../../api/leave-request-api'

moment.locale('ja');

export default {
  name: "work-edit",
  components: {
    SideMenu
  },
  props: {
    userId: {
        type: String,
        default () {
            return null
        }
    },
    targetDates: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data() {
    return {
      showInfo: false,
      targetYear: null,
      targetDate: null,
      initLeaveRequest: false,
      leaveEarly: false,
      invalidLeaveRequestReason: false,
      specialLeaveList: [],
      workEdit: {
          leaveRequestType: null,
          leaveRequestReason: '',
          breakTimeMinHour: 0,
          breakTimeMinMinute: 0,
          otherBreakTimeHour: 0,
          otherBreakTimeMinute: 0,
          midnightBreakTimeHour: 0,
          midnightBreakTimeMinute: 0,
          dayOff: 0,
          specialLeaveCd: null,
      }
    }
  },
  watch: {
    'targetDates': function (val) {
        this.workEdit.specialLeaveCd = null
    },
    // 休暇申請種類
    'workEdit.leaveRequestType': function (val) {
        // 有給以外を選択した場合のクリア
        if (this.workEdit.dayOff == 1 && val == 1) {
            setTimeout(function(){
                $("#yukyu-half-reason").focus()
            }, 0)
        }
        if (this.workEdit.dayOff == 2 && val == 1) {
            setTimeout(function(){
                $("#yukyu-all-reason").focus()
            }, 0)
        }
        // 特別休暇
        if (val == 2) { 
            setTimeout(function(){
                $("#special-holiday-reason").focus()
            }, 0)
            // 特別休暇一覧取得
            this.getSpecialLeaveList()
        }
    },
    // 日付を削除されたら対象日を設定する
    'workEdit.clockInDate': function (val) {
        if (!val) {
            this.workEdit.clockInDate = this.targetDate
        } else {
            this.workEdit.clockInDate = moment(val).format('YYYY-MM-DD')
        }
    },
    'workEdit.clockOutDate': function (val) {
        if (!val) {
            this.workEdit.clockOutDate = this.targetDate
        } else {
            this.workEdit.clockOutDate = moment(val).format('YYYY-MM-DD')
        }
        this.checkLeaveEarly();
    },
    // 時が入力されたら分を0で設定
    'workEdit.clockInHour': function (val) {
        if (val && !this.workEdit.clockInMin) {
            this.workEdit.clockInMin = 0
        }
    },
    'workEdit.clockOutHour': function (val) {
        if (val && !this.workEdit.clockOutMin) {
            this.workEdit.clockOutMin = 0
        }
        this.checkLeaveEarly();
    },
    'workEdit.clockOutMin': function (val) {
        this.checkLeaveEarly();
    },
  },
  mounted() {
    // 個別編集の場合
    if(this.$route.params.targetDate){
        this.targetDate = this.$route.params.targetDate
        this.targetYear = moment(this.targetDate).format("YYYY")
        this.getWorkEdit()
    }

    // 一括編集の場合
    if(this.targetDates.length > 0){
        this.targetYear = moment(this.targetDates[0]).format("YYYY")
        this.$root.$refs.loading.$data.onModal = true
    }
    
  },
  methods: {
    //勤怠取得
    async getWorkEdit () {
        this.$root.$refs.loading.$data.show = true
        this.workEdit = await WorkAPI.getWorkEdit(this.targetDate)
        this.initLeaveRequest = this.workEdit.leaveRequestType != null ? true : false
        this.$forceUpdate();
        this.$root.$refs.loading.$data.show = false
    },
    // 勤怠編集
    async edit () {
        // バリデーション
        var leaveReason = null
        if(this.workEdit.leaveRequestReason) {
            leaveReason = this.workEdit.leaveRequestReason.trim().replace(/^[\s|　]+|[\s|　]+$/g,'')
        }
        if((this.workEdit.leaveRequestType == 1) && !leaveReason){
            this.invalidLeaveRequestReason = true
            return false
        }

        this.$root.$refs.loading.$data.show = true
        // 初期値で休暇申請がある場合、送らない（2度通知が行くため）
        if (this.initLeaveRequest) {
            this.workEdit.leaveRequestType = null
            this.workEdit.leaveRequestReason = ''
        }
        // 特別休暇以外の場合、特別休暇種別の値を削除する
        if (this.workEdit.leaveRequestType != '2') {
            this.workEdit.specialLeaveCd = ''
        }

        // 個別更新
        if (this.targetDate){
            // 日付が空の場合、対象日を設定
            if (!this.workEdit.clockInDate) {
                this.workEdit.clockInDate = this.targetDate
            }
            if (!this.workEdit.clockOutDate) {
                this.workEdit.clockOutDate = this.targetDate
            }
        }

        // 一括更新
        if (this.targetDates.length > 0) {
            this.workEdit.userId = this.userId
            this.workEdit.targetDates = this.targetDates
        }

        await WorkAPI.edit(this.workEdit)
        this.$root.$refs.loading.$data.show = false
        if (this.targetDates.length > 0) {
            this.$router.go(this.$router.currentRoute) // 一括編集はモーダルのため。
        } else {
            this.$router.go(-1)
        }
    },
    // ユーザ情報表示/非表示（スマホ）
    showUserInfo () {
        this.showInfo = !this.showInfo 
    },
    // 休暇種類チェック時
    checkDayOff (val) {
        switch (val) {
            case 3:
                this.workEdit.leaveRequestType = 2
                break;
            default:
                this.workEdit.leaveRequestType = null
                break;
        }
    },
    // 有給チェック時
    checkYukyu (val) {
        if(this.workEdit.leaveRequestType != null){
            this.workEdit.leaveRequestType = null
        } else {
            this.workEdit.leaveRequestType = val
        }
    },
    // 早退チェック
    checkLeaveEarly () {
        if (this.workEdit != null && this.workEdit.clockOutDate != null && this.workEdit.clockOutHour != null && this.workEdit.clockOutMin != null) {
            let clockOut = moment(this.workEdit.clockOutDate, "YYYY-MM-DD");
            clockOut.add(this.workEdit.clockOutHour , 'hours')
            clockOut.add(this.workEdit.clockOutMin, 'minutes')
            if(clockOut.isValid()){
                this.leaveEarly = clockOut.isBefore(this.workEdit.shiftClockOut)
            }
        } else {
            this.leaveEarly = false
        }
    },
    // 特別休暇一覧取得
    async getSpecialLeaveList () {
        this.$root.$refs.loading.$data.show = true
        let params = {}
        params['year'] =  this.targetYear
        params['userId'] =  this.workEdit.userId ? this.workEdit.userId : this.userId
        this.specialLeaveList = await LeaveRequestAPI.getSpLeaveSummary(params)
        this.$root.$refs.loading.$data.show = false
    }
  },
  filters: {
    displayDate: function (data) {
      return data ? moment.localeData().preparse(moment(data).format("YYYY年MM月DD日(ddd)")) : ''
    }
  }
}
</script>


<style lang="scss" scoped>
.el-date-editor.el-input {
    @media screen and (max-width: 767px) {
      width: 140px;
    }
}
.radio-block {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 15px 15px;
    padding-bottom: 0px;
    position: relative;
    margin-top: 25px;
    &>label {
        position: absolute;
        top: -10px;
        left: -3px;
        z-index: 10000;
        background: white;
        padding-right: 5px;
    }
}
</style>


// WEBPACK FOOTER //
// src/assets/js/components/operator/work/WorkEdit.vue